import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { menuItems } from './NavMenu';

export default function MobileMenu({ open, onClose }) {
  const [expanded, setExpanded] = useState(null);
  return <nav id="mobile-navigation" className={open ? 'mobile-menu mobile-menu--open' : 'mobile-menu'} aria-label="Mobile navigation" aria-hidden={!open}>
    <ul>{menuItems.map(item => <li className="mobile-menu__item" key={item.label}>
      {item.children ? <>
        <button type="button" aria-expanded={expanded === item.label} onClick={() => setExpanded(expanded === item.label ? null : item.label)}>{item.label}<FiChevronDown className={expanded === item.label ? 'chevron chevron--open' : 'chevron'} /></button>
        <div className={expanded === item.label ? 'mobile-submenu mobile-submenu--open' : 'mobile-submenu'}><ul>{item.children.map(child => <li key={child.label}><a href={child.href} onClick={onClose}>{child.label}</a></li>)}</ul></div>
      </> : <a href={item.href} onClick={onClose}>{item.label}</a>}
    </li>)}</ul>
    <a className="shop-button mobile-shop" href="/products" onClick={onClose}>SHOP NOW</a>
  </nav>;
}
